<template>
  <div>
    <va-card>
      <va-data-table
        :fields="fields"
        :data="reviews"
        :loading="loading"
        :per-page="10"
        class="va-table va-table--hoverable va-table--clickable"
        no-data-label="Пусто"
      >
        <template slot="created_at" slot-scope="props">
          <span>{{ formatDate(props.rowData.created_at) }}</span>
        </template>
        <template slot="name" slot-scope="props">
          <span>{{ props.rowData.name || 'Анонимный пользователь' }}</span>
        </template>
        <template slot="text" slot-scope="props">
          <span>{{ truncate(props.rowData.text, 50) }}</span>
        </template>
        <template slot="status" slot-scope="props">
          <span v-if="props.rowData.status === 'approved'" class="status--success">Проверено</span>
          <span v-else-if="props.rowData.status === 'deleted'" class="status--error">Удалено</span>
          <span v-else-if="props.rowData.status === 'disapproved'" class="status--error">Скрыто</span>
          <span v-else>На модерации</span>
        </template>
        <template slot="actions" slot-scope="props">
          <div class="reviews-actions">
            <va-button
              small
              color="primary"
              @click.stop="viewHandler(props.rowData)"
            >
              Открыть
            </va-button>
            <va-button
              v-if="props.rowData.status !== 'approved'"
              color="info"
              small
              @click="reviewModification('approve', props.rowData)"
            >
              Одобрить
            </va-button>
            <va-button
              v-if="props.rowData.status !== 'disapproved'"
              color="danger"
              small
              @click="reviewModification('disapprove', props.rowData)"
            >
              Скрыть
            </va-button>
            <va-button
              color="danger"
              small
              @click="reviewModification('remove', props.rowData)"
            >
              Удалить
            </va-button>
          </div>
        </template>
      </va-data-table>
    </va-card>
    <va-modal v-model="viewModal" size="large" hide-default-actions>
      <review-view v-if="currentReview" :review="currentReview" @close="closeModal" />
    </va-modal>
  </div>
</template>

<script>
import api from '@/api/axios';
import ReviewView from './review-view.vue';

export default {
  name: 'ReviewsTable',
  components: {
    ReviewView,
  },
  props: {
    reviews: {
      type: Array,
      required: true,
      default: () => [],
    },
    loading: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      viewModal: false,
      currentReview: null,
    };
  },
  computed: {
    fields() {
      return [
        {
          name: '__slot:created_at',
          title: 'Дата отзыва',
        },
        {
          name: '__slot:name',
          title: 'ФИО',
        },
        {
          name: '__slot:text',
          title: 'Комментарий',
        },
        {
          name: '__slot:status',
          title: 'Статус',
        },
        {
          name: '__slot:actions',
          title: '',
          width: '200px',
        },
      ];
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return '-';
      try {
        const d = new Date(date);
        return d.toLocaleString('ru-RU', { timeZone: 'Asia/Omsk' });
      } catch (e) {
        return date;
      }
    },
    truncate(value, size) {
      if (!value) return '-';
      const str = value.toString();
      if (str.length <= size) {
        return str;
      }
      return str.substr(0, size) + '...';
    },
    viewHandler(review) {
      this.currentReview = review;
      this.viewModal = true;
    },
    closeModal() {
      this.viewModal = false;
      this.currentReview = null;
    },
    async reviewModification(reviewAction, review) {
      const method = reviewAction === 'remove' ? 'delete' : 'post';
      let url = `admin/feedback/${review.id}`;
      
      if (reviewAction === 'approve') {
        url += '/approve';
      } else if (reviewAction === 'disapprove') {
        url += '/disapprove';
      }

      try {
        await api({
          method,
          url,
        });
        this.$emit('refresh');
      } catch (error) {
        console.error('Ошибка модификации отзыва:', error);
        alert('Ошибка при выполнении операции');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.reviews-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  align-items: center;
}

.status {
  &--success {
    color: #42ba96;
    font-weight: bold;
  }
  &--error {
    color: #ff3333;
    font-weight: bold;
  }
}
</style>
